<script setup lang="ts">
import { RouterView } from 'vue-router';
import { onBeforeMount } from 'vue';
import { useApiStore } from '@/stores';

const apiStore = useApiStore();
onBeforeMount(async () => {
  // Try to restore session on app load
  await apiStore.initializeFromStorage();
});
</script>

<template>
  <RouterView />
</template>

<style lang="scss"></style>
